import { BusinessInfoLine } from '../../../MobileInvoiceView/InvoicesBusinessInfo/BusinessInfoLine';
import * as React from 'react';
import { translate } from 'react-i18next';
import { Box } from 'wix-style-react';
export var BusinessCustomFields = translate()(function (_a) {
    var businessCustomFields = _a.businessCustomFields, t = _a.t;
    var customFields = businessCustomFields === null || businessCustomFields === void 0 ? void 0 : businessCustomFields.map(function (_a, index) {
        var displayName = _a.displayName, value = _a.value;
        return (React.createElement(BusinessInfoLine, { key: index, verticalLayout: true, dataHook: "".concat(displayName, "-").concat(index, "-custom-field"), value: t('invoice-view:price-quote.view.custom-field', {
                displayName: displayName,
                value: value,
            }) }));
    });
    var hasCustomFields = (businessCustomFields === null || businessCustomFields === void 0 ? void 0 : businessCustomFields.length) > 0;
    return hasCustomFields ? (React.createElement(Box, { display: "inherit", "data-hook": "business-custom-fields" }, customFields)) : null;
});
//# sourceMappingURL=BusinessCustomFields.js.map